import React from 'react';
import Icon from 'antd/lib/icon';
import Tooltip from 'antd/lib/tooltip';
var ListUserEventRoleItemIcon = function (props) {
    if (!props.userEventRole.user) {
        return null;
    }
    if (props.userEventRole.user.facebookId) {
        return (React.createElement(Icon, { type: 'facebook' }));
    }
    if (props.userEventRole.user.googleId && props.userEventRole.user.userProfile) {
        return (React.createElement(Tooltip, { title: props.userEventRole.user.userProfile.email },
            React.createElement("a", null,
                React.createElement(Icon, { type: 'google' }))));
    }
    return (React.createElement(Tooltip, { title: props.userEventRole.user.email },
        React.createElement("a", null,
            React.createElement(Icon, { type: 'mail' }))));
};
export default ListUserEventRoleItemIcon;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListUserEventRolePage/ListUserEventRoleItemIcon.tsx
// module id = 1082
// module chunks = 0